import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
            <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
                <div className="relative">
                    <div className="absolute">
                        <div>
                            <h1 className="my-2 text-gray-800 font-bold text-2xl">{t('404.title')}</h1>
                            <p className="my-2 text-gray-800">{t('404.subTitle')}</p>
                            <div className="h-2 my-2">
                                <Link
                                    to="/"
                                    className="absolute sm:w-full lg:w-auto my-2 border rounded py-4 px-8 text-center bg-blue-400 text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
                                >
                                    {t('404.btn')}
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img alt="404" src="https://i.ibb.co/G9DC8S0/404-2.png" />
                    </div>
                </div>
            </div>
            <div>
                <img alt="unplugged" src="https://i.ibb.co/ck1SGFJ/Group.png" />
            </div>
        </div>
    );
};

export default NotFound;
